(() => {
  window.swinger.eventHub.register('click', '.swinger-button-watch[data-itemnumber]', (e) => {
    const elem = window.swinger.eventHub.getTarget(e);
    const itemNumber = elem.getAttribute('data-itemnumber');
    const videos = window.swinger.$(`.swinger-video-player[data-itemnumber="${itemNumber}"] video`);

    if (!videos.length) {
      return;
    }

    const video = videos[0];
    const dialog = video.closest('dialog');

    video.play().catch((e) => {
      console.log('Failed starting to play video', e);
    });

    if (dialog) {
      window.swinger.overlayManager.open(dialog);
    } else {
      video.scrollIntoView({
        block: 'nearest',
      });
    }

    e.preventDefault();
    e.stopImmediatePropagation();
  });
})();
